import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import JoinusModel from "../components/JoinusModel";
import ContactUs from "../components/ContactUs";

const Header1 = () => {
  const [menuIsExpanded, setMenuIsExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredLogin, setIsHoveredLogin] = useState(false);
  const [isContactUsModelOpen,setIsContactUsModelOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);

  const { pathname } = useLocation();

  const navigate = useNavigate();
  const [isJoinUsModelOpen,setIsJoinUsModelOpen] = useState(false);
  function joinUs() {
      setIsJoinUsModelOpen(true);
  }

  const handleOffset = () => {
    if (pathname !== "/") {
      setActiveSection(null);
      return;
    }

    const supportUs = document.getElementById("support-us");
    const resources = document.getElementById("resources");
    const getInvolved = document.getElementById("get-involved");
    const aboutUs = document.getElementById("about-us");
    if (!supportUs || !resources) {
      return;
    }
    if (
      window.scrollY >= resources?.offsetTop - 160
    ) {
      setActiveSection("resources");
    } else if (window.scrollY >= supportUs?.offsetTop - 160) {
      setActiveSection("support-us");
    } else if (window.scrollY >= getInvolved?.offsetTop - 160) {
      setActiveSection("get-involved");
    } else if (window.scrollY >= aboutUs?.offsetTop - 160) {
      setActiveSection("about-us");
    } else setActiveSection(null);
  };

  useEffect(() => {
    handleOffset();
    window.addEventListener("scroll", handleOffset);
    return () => window.removeEventListener("scroll", handleOffset);
  }, [pathname]);

  useEffect(() => {
    window.addEventListener("resize", handleOffset);
    return () => window.removeEventListener("resize", handleOffset);
  }, []);
  const handleLogoClick = (e) => {
    e.preventDefault();
    
    if (pathname === "/") {
      // If already on homepage, just scroll to top
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      setActiveSection(null);
    } else {
      // If on another page, navigate to homepage
      navigate("/");
    };
  };

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    
    // Get href from clicked element
    const query = e.target.getAttribute("href");
    if (!query?.startsWith("#")) return;
    
    // Close mobile menu if open
    setMenuIsExpanded(false);
    
    const scrollToElement = () => {
      const element = document.querySelector(query);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 160,
          behavior: "smooth"
        });
      }
    };
  
    // Handle navigation based on current path
    if (pathname === "/") {
      scrollToElement();
    } else {
      navigate("/");
      // Wait for navigation to complete before scrolling
      setTimeout(scrollToElement, 100);
    }
  };
  return (
    <>
    <header className="flex justify-center fixed top-0 w-full bg-white z-50 xxl:h-[152px] lg:h-[145px] h-[100px]">
      <div className="w-full px-20px max-w-[1336px] flex justify-between items-center">
        {pathname === "/" ? (
          <Link to="/" onClick={handleLogoClick}>
            <img src="/brand-logo.png" className="xxl:max-w-full lg:max-w-[75%]  max-w-[65%] cursor-pointer" alt="logo" />
          </Link>
        ) : (
          <Link to="/" onClick={handleLogoClick}>
            <img src="/brand-logo.png" className="xxl:max-w-full lg:max-w-[75%]  max-w-[65%] cursor-pointer" alt="logo" />
          </Link>
        )}

        <button
          className="lg:hidden flex justify-center items-center z-10"
          onClick={() => setMenuIsExpanded((prev) => !prev)}
        >
          {menuIsExpanded ? (
            <img src="/x-mark.svg" alt="close" className="w-9" />
          ) : (
            <img src="/bars.svg" alt="open" className="w-9" />
          )}
        </button>

        <nav
          className={`gap-5 xl:gap-[30px] flex flex-col items-baseline lg:flex-row fixed lg:static right-0 top-0 w-[280px] bg-peach h-full py-20 px-5 lg:p-0 lg:h-auto lg:bg-transparent lg:w-auto transition-transform duration-300 ${
            menuIsExpanded
              ? "translate-x-0"
              : "translate-x-full lg:translate-x-0"
          }`}
        >
          <Link
            to="/about-us"
            onClick={() => {
              setMenuIsExpanded(false);
            }}
            className={`uppercase xl:text-22px xl:leading-8 text-18px leading-[28px] font-fira font-normal hover:text-customRed hover:underline ${
              pathname === "/about-us"
                ? "underline text-customRed"
                : ""
            }`}
          >
            About us
          </Link>
          <a
            href="#support-us"
            onClick={(e) => {
              scrollToSection(e);
              setMenuIsExpanded(false);
            }}
            className={`uppercase xl:text-22px xl:leading-8 text-18px leading-[28px] font-fira font-normal hover:text-customRed hover:underline ${
              activeSection === "support-us"
                ? "underline text-customRed"
                : ""
            }`}
          >
            Support us
          </a>
          <a
            href="#resources"
            onClick={(e) => {
              scrollToSection(e,'resources');
              setMenuIsExpanded(false);
            }}
            className={`uppercase xl:text-22px xl:leading-8 text-18px leading-[28px] font-fira font-normal hover:text-customRed hover:underline ${
              activeSection === "resources"
                ? "underline text-customRed"
                : ""
            }`}
          >
            Resources
          </a>
          <span
            onClick={() => {
              setMenuIsExpanded(false);
              setIsContactUsModelOpen(true);
            }}
            className={`uppercase xl:text-22px xl:leading-8 text-18px leading-[28px] font-fira font-normal hover:text-customRed hover:underline cursor-pointer`}
          >
            Contact Us
          </span>
          <span
            className={`uppercase xl:text-22px xl:leading-[23.4px] text-18px leading-[23px] font-fira font-normal hover:bg-darkRed bg-customRed text-white flex items-center xl:py-[14.3px] xl:px-6 py-2 px-3 leading-[23.4px] cursor-pointer`}
            onClick={() => {
              setMenuIsExpanded(false);
              joinUs();
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <span className="xl:pr-5 pr-3">Join Us</span>
            <img className="w-[8px] h-[14px]" src={"/arrow_forward.svg"} alt="arrow_forward" />
          </span>
          <Link
            to="/login"
            onClick={() => setMenuIsExpanded(false)}
            className={`uppercase xl:text-22px xl:leading-[23.4px] text-18px leading-[23px] font-fira font-normal hover:bg-darkRed bg-customRed text-white flex items-center xl:py-[14.3px] xl:px-6 py-2 px-3 leading-[23.4px] ${
              pathname === "/login" ? "" : ""
            }`}
            onMouseEnter={() => setIsHoveredLogin(true)}
            onMouseLeave={() => setIsHoveredLogin(false)}
          >
            <span className="xl:pr-5 pr-3">Login</span>
            <img className="w-[8px] h-[14px]" src={"/arrow_forward.svg"} alt="arrow_forward" />
          </Link>
        </nav>
      </div>
      {isJoinUsModelOpen && <JoinusModel closeModel={()=> setIsJoinUsModelOpen(false)}/> }
    </header>
    {isContactUsModelOpen && <ContactUs closeModel={() => setIsContactUsModelOpen(false)}/>}          
    </>
  );
};

export default Header1;
